import React, { useState, useEffect, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import "./SideBar.css";

import Drawer from "@mui/material/Drawer";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import DrawerSidebar from "./DrawerSidebar";
import { Context } from "../../context/Context";

import DashImg from "../../assets/images/side_dash.svg";
import DashActive from "../../assets/images/side_dash_active.svg";

import ClipBoard from "../../assets/images/side_clipboard.svg";
import ClipBoardActive from "../../assets/images/side_clipboard_active.svg";

import PTSession from "../../assets/images/run_line.svg";
import PTSessionActive from "../../assets/images/run_line_active.svg";

import MyPatients from "../../assets/images/side_heart.svg";
import MyPatientsActive from "../../assets/images/side_heart_active.svg";

import Messages from "../../assets/images/side_message.svg";
import MessagesActive from "../../assets/images/side_message_active.svg";

import Report from "../../assets/images/side_chart.svg";
import ReportActive from "../../assets/images/side_chart_active.svg";

import Questionnaire from "../../assets/images/side_help.svg";
import QuestionnaireActive from "../../assets/images/side_help_active.svg";

import SideClients from "../../assets/images/clients.svg";
import SideClientsActive from "../../assets/images/clients_active.svg";

import Settings from "../../assets/images/side_settings.svg";
import SettingsActive from "../../assets/images/side_settings_active.svg";

import Logout from "../../assets/images/side_logout.svg";
import LogoutActive from "../../assets/images/side_logout_active.svg";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#1e1e1e",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#1e1e1e",
    fontSize: theme.typography.pxToRem(14),
    padding: "10px 15px",
    marginLeft: "20px",
    pointerEvents: "none",
  },
}));

const SideBar = (props) => {
  
  const { showDrawerSidebar, setShowDrawerSidebar, clearAllData } = useContext(Context);
  const location = useLocation();

  const isSuperAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).super_admin === 1
        ? true
        : false
      : false;

  const isCompanyAdmin =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).company_admin === 1
        ? true
        : false
      : false;

  const isTherapist =
    localStorage.getItem("userData") &&
    JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).user_type === 2
        ? true
        : false
      : false;

  const param = window.location.href.split("/")[3];
  const navigate = useNavigate();
  const [activeOpt, setActiveOpt] = useState(param);
  const [unreadCount, setMessagesUnreadCount] = useState(0);

  useEffect(() => {
    setActiveOpt(window.location.href.split("/")[3]);
  }, [param]);

  const changeActiveOpt = (opt) => {
    const isOnProgramPage = location.pathname === "/newprogram" || location.pathname.includes("/details/");
    const isDirty = localStorage.getItem("isDirty") === "true";

    if (isOnProgramPage && isDirty) {
      const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to leave this page?");
      if (!confirmLeave) return;
    }

    setActiveOpt(opt);
    navigate("/" + opt);
  };

  const logUserOut = () => {
    const isOnProgramPage = location.pathname === "/newprogram" || location.pathname.includes("/details/");
    const isDirty = localStorage.getItem("isDirty") === "true";

    if (isOnProgramPage && isDirty) {
      const confirmLeave = window.confirm("You have unsaved changes. Are you sure you want to logout?");
      if (!confirmLeave) return;
    }

    localStorage.removeItem("userData");
    props.checkLoggedIn(false);
    clearAllData();
    navigate("/login", {replace: true})
  };

  useEffect(() => {
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      getUnreadMessages();
    }
  }, [param, props]);

  const getUnreadMessages = () => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "notifications/getUnreadCount", {})
      .then((res) => {
        if (res.data.responseData) {
          setMessagesUnreadCount(res.data.responseData[1]["unread_count"]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("userData")) &&
      JSON.parse(localStorage.getItem("userData")).id
    ) {
      const eventSource = new EventSource(
        window.ajaxLink +
          "updatesse/events?observeData=patientChat&valueName=" +
          JSON.parse(localStorage.getItem("userData")).id.toString()
      );
      eventSource.onmessage = (e) => {
        if (e.data.toString().toLowerCase() == "update") {
          getUnreadMessages();
        }
      };
      return () => {
        eventSource.close();
      };
    }
  }, []);

  return (
    <div className="sidebar_container">
      <div className="sidebar_inner_container_main">
        <div className="logo_black"></div>
        <div className="sidebar_options">
          {isTherapist && (
            <>
              <BootstrapTooltip title="Dashboard" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "dashboard" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("dashboard")}
                >
                  <img
                    src={activeOpt === "dashboard" ? DashActive : DashImg}
                    alt="dashboard"
                  />
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="Recovery Plan" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "programs" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("programs")}
                >
                  <img
                    src={activeOpt === "programs" ? ClipBoardActive : ClipBoard}
                    alt="Recovery Plan"
                  />
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="PT Sessions" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "workouts" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("workouts")}
                >
                  <img
                    src={activeOpt === "workouts" ? PTSessionActive : PTSession}
                    alt="workouts"
                  />
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="My Patients" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "myPatients" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("myPatients")}
                >
                  <img
                    src={
                      activeOpt === "myPatients" ? MyPatientsActive : MyPatients
                    }
                    alt="myPatients"
                  />
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="Messages" placement="right">
                <div
                  className={
                    "sidebar_option side_info_messages " +
                    (activeOpt === "messages" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("messages")}
                >
                  <img
                    src={activeOpt === "messages" ? MessagesActive : Messages}
                    alt="messages"
                  />
                  {unreadCount > 0 && (
                    <span
                      style={{
                        left: "10px",
                        top: "5px",
                      }}
                      className="menu_bell_counter counter_three"
                    >
                      {unreadCount}
                    </span>
                  )}
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="Reports" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "reports" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("reports")}
                >
                  <img
                    src={activeOpt === "reports" ? ReportActive : Report}
                    alt="reports"
                  />
                </div>
              </BootstrapTooltip>

              <BootstrapTooltip title="Questionnaires" placement="right">
                <div
                  className={
                    "sidebar_option " +
                    (activeOpt === "questionnaires" ? "active" : "")
                  }
                  onClick={() => changeActiveOpt("questionnaires")}
                >
                  <img
                    src={
                      activeOpt === "questionnaires"
                        ? QuestionnaireActive
                        : Questionnaire
                    }
                    alt="questionnaires"
                  />
                </div>
              </BootstrapTooltip>

              {isSuperAdmin && (
                <BootstrapTooltip title="Clients" placement="right">
                  <div
                    className={
                      "sidebar_option " +
                      (activeOpt === "clients" ? "active" : "")
                    }
                    onClick={() => changeActiveOpt("clients")}
                  >
                    <img
                      src={
                        activeOpt === "clients"
                          ? SideClientsActive
                          : SideClients
                      }
                      alt="clients"
                    />
                  </div>
                </BootstrapTooltip>
              )}
            </>
          )}

          <BootstrapTooltip title="Settings" placement="right">
            <div
              className={
                "sidebar_option " + (activeOpt === "settings" ? "active" : "")
              }
              onClick={() => changeActiveOpt("settings")}
            >
              <img
                src={activeOpt === "settings" ? SettingsActive : Settings}
                alt="clients"
              />
            </div>
          </BootstrapTooltip>

          <BootstrapTooltip title="Log Out" placement="right">
            <div
              className={
                "sidebar_option " + (activeOpt === "logout" ? "active" : "")
              }
              style={{ marginTop: "50px", marginBottom: "30px" }}
              onClick={() => logUserOut()}
            >
              <img
                src={activeOpt === "logout" ? LogoutActive : Logout}
                alt="clients"
              />
            </div>
          </BootstrapTooltip>
        </div>
      </div>

      <Drawer
        open={showDrawerSidebar}
        onClose={() => setShowDrawerSidebar(false)}
      >
        <DrawerSidebar checkLoggedIn={props?.checkLoggedIn} setShowDrawerSidebar={setShowDrawerSidebar} />
      </Drawer>
    </div>
  );
};

export default SideBar;
